import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function GoogleCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");

  useEffect(() => {
    const code = params.get("code");
    const state = params.get("state") || "login";
    if (!code) { setErr("Missing code"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { code, state });
        if (data.token) localStorage.setItem("gw_token", data.token);
        await refresh();
        const forgot = window.sessionStorage.getItem("gw_forgot_password") === "1";
        if (forgot) {
          nav("/reset-password");
          return;
        }
        nav(state === "link" ? "/sync" : "/");
      } catch (e) {
        setErr(e.response?.data?.detail || "Google sign-in failed");
      }
    })();
    // eslint-disable-next-line
  }, []);

  if (err) return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <h2 className="font-display text-2xl font-bold text-red-600 mb-2">Sign-in failed</h2>
        <p className="text-slate-600 mb-4">{typeof err === "string" ? err : "Unknown error"}</p>
        <button onClick={() => nav("/login")} className="text-indigo-600 underline">Back to login</button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-600 mx-auto mb-3" />
        <p className="text-slate-500">Completing sign-in…</p>
      </div>
    </div>
  );
}
